import AccountSource from 'src/models/accounting/AccountSource'
import Model, { encoders, ID, Integer, IsoDate, MODEL_LEVEL } from 'src/models/model'
import Tax from 'src/models/order/Tax'

export default class JournalEntry extends Model {
  static name = 'JournalEntry'

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Financial]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      date: {
        type: IsoDate,
        default: null,
        sortable: true
      },
      accountSource: {
        type: AccountSource,
        reference: true,
        default: null,
        encode: encoders.hasOne
      },
      description: {
        type: String
      },
      isManual: {
        type: Boolean,
        default: true
      },
      isContra: {
        type: Boolean,
        default: true
      },
      tax: {
        type: Tax,
        reference: true,
        output: true
      },
      netAmount: {
        type: Number,
        encode: encoders.money,
        default: null
      },
      grossAmount: {
        type: Number,
        encode: encoders.money,
        default: null
      },
      taxAmount: {
        type: Number,
        encode: encoders.money,
        default: null
      },
      amount: {
        type: Number,
        encode: encoders.money,
        default: null
      },
      points: {
        type: Integer
      },

      action: {
        type: String,
        input: true
      }
    }
  }
}
